import axios from '@/libs/api.request'

const prefix = '/print/tmall/after-sale'

export const GetTmallAfterSaleList = data => {
  return axios.request({
    url: `${prefix}/list`,
    params: data,
    method: 'get'
  })
}

export const GetTmallAfterSaleDetail = data => {
  return axios.request({
    url: `${prefix}/detail`,
    params: data,
    method: 'get'
  })
}

export const AuditTmallAfterSale = data => {
  return axios.request({
    url: `${prefix}/audit`,
    data,
    method: 'post'
  })
}

export const GetTmallAfterSaleTypes = data => {
  return axios.request({
    url: `${prefix}/types`,
    params: data,
    method: 'get'
  })
}

export const SaveTmallAfterSaleType = data => {
  return axios.request({
    url: `${prefix}/type`,
    data,
    method: 'post'
  })
}

export const DelTmallAfterSaleType = data => {
  return axios.request({
    url: `${prefix}/type/del`,
    data,
    method: 'post'
  })
}
